import "./concurrentDedupe.js";
import { fetchCache as w, createCache as g } from "./cache.js";
import { getInFlightDedupeKey as y, fetchWithInFlightDedupe as m } from "./fetchInFlightDedupe.js";
import { applyRequestInterceptors as _, applyResponseInterceptors as k, processFetchError as v } from "./fetchInterceptors.js";
const F = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function U(e) {
  const t = F[e];
  return typeof t == "string" ? t : void 0;
}
function D(e) {
  const o = e.isDev ?? !1, t = e.apiProxyUrl ?? U("H9_API_PROXY_URL"), n = typeof window < "u" && window.location.host.includes("localhost");
  return !!(o && !t && n);
}
const I = typeof window < "u" ? window.fetch.bind(window) : fetch;
function S(e) {
  const o = D(e), t = {
    getCurrentUser: e.getCurrentUser,
    logout: e.logout
  };
  window.fetch = function(n, l) {
    const c = n.toString(), r = l || {};
    return new Promise((s, a) => {
      (async () => {
        try {
          if (!o) {
            if (await w(c, r, s, a))
              return;
            const [f, h] = await _(n, r), p = y(f, h), d = await m(p, async () => {
              let i = await I(f, h);
              return i.ok && (i = await k(i)), i;
            });
            if (!d.ok)
              throw d;
            g(c, r, d, s, a);
            return;
          }
          const {
            getFakeData: u
          } = await import(
            /* @vite-ignore */
            e.fakeBackendModulePath
          );
          u(c, r, s, a);
        } catch (u) {
          await v(u, a, t);
        }
      })();
    });
  };
}
export {
  S as configureFetch,
  I as realFetch
};
